<div class="sub-header">
  <mat-icon
    *ngIf="!department || department.id === 0"
    svgIcon="first-login-arrow-icon"
    class="no-departmnet"></mat-icon>
  <mat-icon
    *ngIf="department && (!resident || resident.id === 0)"
    svgIcon="arrow_short"
    class="no-resident"></mat-icon>
  <div class="resident-info-container sub-header-part">
    <div class="no-resident-text">
      {{
        !department || department.id === 0
          ? 'Bitte wählen Sie zunächst Wohnbereich und Bewohner:in aus, für wen Sie einkaufen möchten'
          : 'Für den ausgewählten Wohnbereich sind aktuell noch keine Bewohner:innen angelegt.'
      }}
    </div>
  </div>
  <button class="close-button" (click)="closeDialog()">
    <mat-icon svgIcon="close-icon"></mat-icon>
  </button>
  <div class="sub-header-part order-button">
    <mat-icon svgIcon="order-icon" class="order-icon"></mat-icon>
    <span>
      Zur
      <br />
      Kasse
    </span>
  </div>

  <div
    style="
      background-color: #1a1926;
      opacity: 0.64;
      position: fixed;
      top: 288px;
      left: 0;
      bottom: 0;
      right: 0;
    "></div>
</div>
